<template>
    <main class="main-view">
      <router-view></router-view>
    </main>
</template>
<script>
export default {
  name:'mainLayout',
  data(){
    return {

    }
  },
  components: {

  },
  mounted() {

  },
  methods: {

  }
};
</script>

<style scoped>

</style>
